import Styles from './ArrayInput.module.scss'
import InputStyles from 'almanac-ui/TextInputField/Input.module.scss'
import cx from 'classnames'
import { TagInput } from './TagInput'
import { FieldProps } from './Types'
import { SelectPillsMultiInput } from 'components/Wizards/Wizard/Form/SelectPillsMultiInput'
import { Item } from '@react-stately/collections'

export const ArrayInput = ({ name, schema, autoFocus }: FieldProps) => {
  const schemaDescription = schema.describe()
  const meta = schemaDescription.meta as any
  const { placeholder, label, oneOfPills, pillsCarousel, size, options } = meta

  if (options && oneOfPills) {
    return (
      <SelectPillsMultiInput name={name} aria-label={label} isCarousel={pillsCarousel} size={size} chipVariant="flat">
        {options.map((option: string) => (
          <Item key={option}>{option}</Item>
        ))}
      </SelectPillsMultiInput>
    )
  }

  return (
    <div className={cx(InputStyles['lg'], Styles.tagInputContainer)}>
      <TagInput
        name={name}
        placeholder={placeholder}
        autoFocus={autoFocus}
        placeholderClassName={Styles.placeholder}
        minHeight={85}
        showRemoveButton={false}
        variant="modern"
      />
    </div>
  )
}
